<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ data.title }}</h1>

<div mat-dialog-content class="mbp-confirm-dialog__content confirm-batch-request-dialog__content">
  <p class="confirm-batch-request-dialog__message">{{ data.message }}</p>

  <mat-form-field appearance="outline" class="confirm-batch-request-dialog__field">
    <mat-label>Batch number</mat-label>
    <input required [formControl]="batchNumber" matInput />
  </mat-form-field>
</div>

<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button type="button" mat-stroked-button [mat-dialog-close]="false">No</button>
  <button
    type="button"
    [disabled]="!batchNumber.valid"
    mat-flat-button
    [mat-dialog-close]="{ confirm: true, batch_number: batchNumber.value }"
    color="primary"
    cdkFocusInitial
  >
    Yes
  </button>
</div>
